import empresaApi from '@/app-modulo/comuns/empresa/shared/services/api'

export function novaOportunidadeBase() {
  return {
    title: '',
    estimatedValue: 0,
    companyId: 0,
    personId: 0,
    pipelineId: null,
    company: null,
    person: null,
  }
}

export function hidratarCamposLivresDoCadastro(empresa) {
  if (!empresa) return {}
  const porteDoCadastro = empresa.porte
    || empresa.porteEmpresa
    || empresa.tamanho
    || ''
  return {
    porte: porteDoCadastro || '',
  }
}

export function extrairCnaePrincipal(empresa) {
  if (!empresa) return ''

  const c = empresa.cnaePrincipal
    || empresa.cnae
    || (empresa.cnaePrincipalObj || null)
    || (empresa.cnaePrincipal && empresa.cnaePrincipal.descricao ? empresa.cnaePrincipal : null)

  if (typeof c === 'string') return c.trim()

  if (c && typeof c === 'object') {
    const codigo = c.codigo || c.code || c.id || ''
    const desc = c.descricao || c.description || c.nome || ''
    return [codigo, desc].filter(Boolean).join(' - ').trim()
  }

  const codigo = empresa.cnaePrincipalCodigo || empresa.cnaeCodigo || ''
  const desc = empresa.cnaePrincipalDescricao || empresa.cnaeDescricao || ''
  return [codigo, desc].filter(Boolean).join(' - ').trim()
}

export function extrairEnquadramento(empresa) {
  if (!empresa) return ''

  const base = empresa.cadastro || empresa.dadosCadastrais || empresa

  const v = base.enquadramento
    || base.enquadramentoFiscal
    || base.enquadramentoTributario
    || base.regimeTributario
    || base.regime
    || base.regimeDeTributacao
    || base.tipoEnquadramento
    || ''

  if (v && typeof v === 'object') {
    const desc = v.descricao || v.description || v.nome || ''
    return typeof desc === 'string' ? desc.trim() : ''
  }

  return typeof v === 'string' ? v.trim() : ''
}

export function formatarEnderecoEmpresa(empresa) {
  if (!empresa) return ''
  const e = empresa.endereco || empresa.address || null
  if (!e) return ''

  const ufSigla = (e.uf && e.uf.sigla) ? e.uf.sigla : (e.ufSigla || e.uf || '')
  const logradouro = e.logradouro || e.rua || e.street || ''
  const numero = e.numero || e.number || ''
  const complemento = e.complemento || e.complement || ''
  const bairro = e.bairro || e.district || ''
  const cidade = e.cidade || (e.municipio && (e.municipio.nome || e.municipio)) || e.city || ''
  const cep = e.cep || e.zip || e.postalCode || ''

  const parteRua = [logradouro, numero].filter(Boolean).join(', ')
  const linha1 = [parteRua, complemento].filter(Boolean).join(' ')
  const parteCidadeUf = [cidade, ufSigla].filter(Boolean).join('/')
  const linha2 = [bairro, parteCidadeUf, (cep ? `CEP ${cep}` : '')].filter(Boolean).join(' - ')

  return [linha1, linha2].filter(Boolean).join(' - ')
}

export async function getEmpresa(empresaId) {
  if (!empresaId) return null
  return empresaApi.getEmpresa(empresaId)
}
